import React, { useState } from 'react';

import { Trans, useTranslation } from 'react-i18next';

import useRequestError from 'components/hooks/useRequestError';

import FilledButton from 'components/application/buttons/FilledButton';
import SuccessToast from 'components/application/SuccessToast';
import TextField from 'components/application/TextField';

import { useBreadBoard } from 'components/contexts/Toaster';

export default function BillingForm({ email }) {
  const breadBoard = useBreadBoard();

  const [billingEmail, setBillingEmail] = useState(email);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [
    requestError,
    _submitDisabled,
    removeErrorStyling,
    resetRequestError,
    handleRequestError,
  ] = useRequestError();

  const { t: i18nT } = useTranslation('components', {
    keyPrefix: 'settings.billing.BillingForm',
  });

  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  const handleSubmit = () => {
    setIsSubmitting(true);

    axios
      .patch('/billing_account', { billing_account: { email: billingEmail } })
      .then(() => {
        resetRequestError();

        breadBoard.addToast(
          <SuccessToast
            message={
              <Trans
                components={{ span: <span className='tw-font-medium' /> }}
                i18nKey='settings.billing.BillingForm.handleSubmit.success'
                ns='components'
              />
            }
          />,
        );
      })
      .catch((e) => {
        handleRequestError(e);

        breadBoard.addInedibleToast({
          fullMessage: i18nT('handleSubmit.error'),
        });
      })
      .finally(() => setIsSubmitting(false));
  };

  const handleEmailChange = (e) => {
    removeErrorStyling(e);
    setBillingEmail(e.target.value);
  };

  return (
    <div className='tw-max-w-300'>
      <TextField
        customMargin='tw-m-0'
        fieldError={requestError.validationErrors.billingEmail}
        label={i18nT('billingEmail.label')}
        name='billingEmail'
        onChange={handleEmailChange}
        value={billingEmail}
      />
      <FilledButton
        className='tw-mt-5'
        color='mint'
        disabled={isSubmitting}
        onClick={handleSubmit}
      >
        {i18nTShared('saveChanges')}
      </FilledButton>
    </div>
  );
}
